export const modifyUrlToRedirect = (originalUrl: string, newPath: string) => {
    try {
        const url = new URL(originalUrl);

        url.pathname = newPath;
        url.search = '';

        // console.log(url.toString());
        return url.toString();
    } catch (error) {
        console.error('Invalid URL:', error);
        return originalUrl;
    }
};
